import { render, staticRenderFns } from "./questCompleted.vue?vue&type=template&id=36ed94cc&scoped=true"
import script from "./questCompleted.vue?vue&type=script&lang=js"
export * from "./questCompleted.vue?vue&type=script&lang=js"
import style0 from "./questCompleted.vue?vue&type=style&index=0&id=36ed94cc&prod&scoped=true&lang=scss"
import style1 from "./questCompleted.vue?vue&type=style&index=1&id=36ed94cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ed94cc",
  null
  
)

export default component.exports